import SettingsState from "@/store/types/SettingsState";
import { Module, MutationTree, GetterTree } from "vuex";
import AdcontrolProfile from "@/models/AdcontrolProfile";
import ClientUserInfo from "@/models/Agents/UserInfo";

export const state: SettingsState = {
  profile: undefined,
  agentUserInfos: undefined,
  agentView: undefined,
};

export const getters: GetterTree<SettingsState, unknown> = {
  profile(state) {
    return state.profile;
  },

  agentUserInfos(state) {
    return state.agentUserInfos;
  },

  agentView(state) {
    return state.agentView;
  },
};

export const mutations: MutationTree<SettingsState> = {
  setProfile(state, profile: AdcontrolProfile | undefined) {
    state.profile = profile;
  },

  setAgentUserInfos(state, agentUserInfos: ClientUserInfo | undefined) {
    state.agentUserInfos = agentUserInfos;
  },

  setAgentView(state, agentView: boolean | undefined) {
    state.agentView = agentView;
  },

  clearSettings(state) {
    state.profile = undefined;
  },
};

export const settings: Module<SettingsState, unknown> = {
  namespaced: false,
  state,
  getters,
  mutations,
};
